<template>
    <div class="content no-flex active">
        <ed-section class="no-flex active pad"
          wide
          :key="model.InvoiceInformation.programId"
        >
            <div class="section-title">
                <span class="h5">{{model.GridTitle}} Allocation</span>
                <br/>
                <div class="pull-right small"></div>
            </div>
            <div class="col-md-12">
                <grid
                layout="frame"
                :class="{ simple: false }"
                :label="model.Label"
                search="search"
                :views="false"
                :pinning="false"
                :sorting="false"
                :fit-columns="true"
                :checkboxes="true"
                :show-column-selector="false"
                auto-height="auto-height"
                :allow-export="false"
                :model="model.GridModel"
                :data="model.AllocationList"
                totals="totals"
                :total="subtotal"
                :actions='actions'
                @changeRow='changeRow'
                @removeRow="removeRow"
                @removeRows="removeRows"
                ref="allocations"
                :currency-code="currencyCode"
                name='allocations'
                remove-many="remove-many"
                >
                <span slot="additionalButtons">
                    <ed-button class="btn btn-actionbar"
                    name='add_allocation'
                    @click="add"
                    >Add
                    </ed-button>
                </span>
                </grid>
            </div>
            <div class="clear"/>
            <br />
        </ed-section>
    </div>
</template>

<script>
import Grid from '@/components/Grid'
import { remove } from '@/components/Grid/cells/actions'

import AllocationsStore from './AllocationsSection/AllocationsStore.js'

import { Eved, EventBus } from '@/event-bus'

export default {
  components: {
    Grid
  },

  props: {
    model: Object,
    currencyCode: String,
    invoiceAmount: Number,
    vatAmount: Number,
    additionalNoRequired: Boolean
  },
  data() {
    return {
      allocations: [],
      subtotal: '0',
      formulas: {
        'Percent': (percent) => Math.round((this.totalInvoiceAmount * percent / 100) * 100) / 100,
        'Amount': (amount) => Math.round((amount * 100 / this.totalInvoiceAmount) * 100) / 100
      },
      columnToUpdate: {
        'Amount': 'Percent',
        'Percent': 'Amount'
      },
      validateNumeric: {
        'Percent': () => true,
        'Amount': () => true
      },
      totalInvoiceAmount: 0,
      validAllocations: true
    }
  },

  watch: {
    invoiceAmount() {
      this.updateHighLevelGrid()
    },

    vatAmount() {
      this.updateHighLevelGrid()
    }
  },

  computed: {
    actions() {
      return [remove]
    }
  },

  created() {
    this.updateTotal()
    this.setTotalInvoiceAmount()
    this.setValidTotalForGrid()
  },

  methods: {
    store() {
      return new AllocationsStore(this.api)
    },

    add() {
      var item = {
        'Id': '',
        'Name': '',
        'Amount': '0',
        'Percent': '0',
        'AdditionalNo': ''
      }
      this.model.AllocationList.splice(0, 0, item)
      this.updateGrid()
    },

    changeRow(item, type) {
      this.validateRow(item.data)
      this.validateNumericFields(item)
      this.updateAllocation(item)
      this.handleRoundingIssues()
      this.updateAdditionalNo(item)
      this.changeAllocation()
    },

    validateNumericFields(item) {
      if (this.validateNumeric[item.columnId] && this.validateNumeric[item.columnId]()) {
        if (isNaN(item.data[item.columnId])) {
          item.data[item.columnId] = 0
        }
      }
    },

    validateRow(item) {
      let isValid = true
      if (item.Name === '') {
        item._invalid = 'true'
        isValid = false
      }
      if (this.additionalNoRequired && !item.AdditionalNo) {
        item._invalid = 'true'
        isValid = false
      }
      if (isValid) {
        item._invalid = ''
      }
    },

    updateAllocation(item) {
      if (this.formulas[item.columnId] && this.totalInvoiceAmount) {
        item.data[this.columnToUpdate[item.columnId]] = this.formulas[item.columnId](+Number(item.data[item.columnId]))
      }
    },

    updateAdditionalNo(item) {
      let allocation = this.model.SelectionList.filter(modelItem => modelItem.Value === item.data.Name)[0]
      if (allocation) {
        if (item.columnId === 'Name') {
          item.data.AdditionalNo = allocation.AdditionalNo
          item.data.Id = allocation.Key
        }
      }
    },

    updateAllAllocations() {
      this.model.AllocationList.map(item => {
        var newItem = {}
        newItem.columnId = 'Percent'
        newItem.data = item
        this.updateAllocation(newItem)
        item = newItem

        return item
      })
      this.handleRoundingIssues()
      this.changeAllocation()
    },

    // (CORP-239) Handle rounding issues by tampering total allocated to last category
    // https://evedllc.atlassian.net/browse/WORKFLOW-239
    handleRoundingIssues() {
      let sumOfPercent = 0
      let sumOfAmount = 0

      this.model.AllocationList.map(item => {
        if (item.Percent) {
          sumOfPercent += Number(item.Percent)
        }
        if (item.Amount) {
          sumOfAmount += Number(item.Amount)
        }
      })

      if (sumOfPercent === 100) {
        if (sumOfAmount !== this.totalInvoiceAmount) {
          let sumToUpdate = this.totalInvoiceAmount - sumOfAmount
          // update last allocation
          this.model.AllocationList.map((item, index) => {
            if (index === this.model.AllocationList.length - 1) {
              item.Amount = (Number(item.Amount) + sumToUpdate).toFixed(2)
            }
          })
        }
      }
    },

    async changeAllocation() {
      this.updateTotal()
      let payload = {
        Type: this.model.Type,
        Allocation: this.model.AllocationList,
        ValidAllocations: this.checkAllocationsAreValid()
      }
      this.updateGrid()
      EventBus.$emit(Eved.I2P.CHANGE_ALLOCATION, payload)
    },

    checkAllocationsAreValid() {
      let valid = true
      this.model.AllocationList.map(item => {
        this.validateRow(item)
        if (item._invalid === 'true') {
          valid = false
        }
      })
      return valid
    },

    updateGrid() {
      this.$refs.allocations && this.$refs.allocations.updateRowData()
    },

    async removeRow(payload, success, fail) {
      this.model.AllocationList.splice(+payload.index, 1)
      await this.changeAllocation()
      success()
    },

    async removeRows(payload, success) {
      let itemsToDelete = payload.rows.map(k => k.data)
      let indexesOfItemsToDelete = []
      this.model.AllocationList.map((item, index) => {
        if ((itemsToDelete.indexOf(item) > -1)) {
          indexesOfItemsToDelete.push(index)
        }
      })
      indexesOfItemsToDelete.map((item, index) => {
        this.model.AllocationList.splice((item - index), 1)
      })
      await this.changeAllocation()
      this.updateGrid()
      success()
    },

    updateTotal() {
      let total = 0
      let totalPercent = 0
      this.model.AllocationList.forEach(item => {
        if (item.Amount) {
          total = total + +item.Amount
        }
        if (item.Percent) {
          totalPercent += Number(item.Percent)
        }
      })
      this.subtotal = +total
      this.model.TotalPercent = totalPercent
      this.setValidTotalForGrid()
    },

    updateHighLevelGrid() {
      // For: Category Allocation grid
      // Percentage and Amount is calculated based on Amount - VATGST

      this.setTotalInvoiceAmount()
      this.updateGrid()
      this.updateAllAllocations()
    },

    setTotalInvoiceAmount() {
      if (!isNaN(this.invoiceAmount)) {
        if (!isNaN(this.vatAmount)) {
          this.totalInvoiceAmount = this.invoiceAmount - this.vatAmount
        } else {
          this.totalInvoiceAmount = this.invoiceAmount
        }
      }
    },

    setValidTotalForGrid() {
      if (this.model.GridModel.Amount.validSum) {
        this.model.GridModel.Amount.validSum.value = this.totalInvoiceAmount
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/I2P/HighAllocationSection.vue